import React from "react";
import "../App.css";
import { Member } from "../constants/interfaces";

interface TeamProps {
  data: Member[];
}

const Team = (props: TeamProps) => {


  // TODO: move to constants later, set types
  const rolePriority : any = {
    "President": 1,
    "VP - Outreach": 2,
    "VP - Technical": 3,
    "Hiring Director": 4,
    "Treasurer": 5,
    "Project Manager": 6,
    "Technical Lead" : 7,
    "Software Developer": 8,
    "UI/UX Designer": 9,
    "Outreach": 10,
    "Other": 11
  };

  const sortedData = props.data.sort((a, b) => {
    const roleA = a.job;
    const roleB = b.job;
    return (rolePriority[roleA] || rolePriority["Other"]) - (rolePriority[roleB] || rolePriority["Other"]);
  });

  return (
    <div className="team-section">
      <h2 className="team-header">Our Team</h2>
      <div className="team-grid">
        {sortedData.map((member, index) => (
          <div key={index} className="team-member">

            <a href={member.linkedIn} target="_blank" rel="noreferrer">
              <img
                src={`/img/team/${member.name.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join('_')}.jpg`}
                alt={member.name}
                className="team-img"
                onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) => {
                  const target = e.target as HTMLImageElement;
                  target.src = '/img/team/default-icon.jpg';  // Fallback to default image
                }} 
              />

            </a>
            <h3 className="team-name">{member.name} </h3>
            <p className="team-role">{member.job}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Team;
